/**
 * 🟥 CUADRO NEGRO API Insights v1 (feb-2026) — servicios fetch.
 *
 * Llama a los endpoints REST `/api/insights/{summary,tools,recommendations,alerts}`
 * usando `REACT_APP_BACKEND_URL` para que funcione tanto en preview como
 * en producción (`damyxia.com`). Cookies httpOnly se mandan vía
 * `credentials: 'include'` por si el backend pide auth.
 */
const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

async function getJson(path) {
  const res = await fetch(`${BASE}${path}`, { credentials: 'include' });
  return res.json();
}

export async function fetchSummary(userId) {
  return getJson(`/api/insights/summary?user_id=${encodeURIComponent(userId)}`);
}

export async function fetchTools(userId) {
  return getJson(`/api/insights/tools?user_id=${encodeURIComponent(userId)}`);
}

export async function fetchRecommendations(userId) {
  return getJson(`/api/insights/recommendations?user_id=${encodeURIComponent(userId)}`);
}

export async function fetchAlerts(userId) {
  return getJson(`/api/insights/alerts?user_id=${encodeURIComponent(userId)}`);
}
